import {
  ButtonDropdown,
  ButtonDropdownProps,
  IconButton,
  IconButtonProps,
  TABLE_CELL_NOT_CLICKABLE_CLASS,
} from '@billy/design-system'
import { ReactElement } from 'react'

import { DocumentStaticActionType } from './enums/documentStaticActionType'
import { useDocumentActionItems } from './hooks/useDocumentActionItems'

interface DocumentStaticActionsProps extends Omit<ButtonDropdownProps<DocumentStaticActionType>, 'items' | 'onSelect'> {
  visibleActions: DocumentStaticActionType[]
  onSelect: (action: DocumentStaticActionType) => void
  triggerVariant?: IconButtonProps['variant']
}

export const DocumentStaticActions = ({
  visibleActions,
  onSelect,
  triggerVariant = 'text',
  ...rest
}: DocumentStaticActionsProps): ReactElement | null => {
  const documentActionItems = useDocumentActionItems(visibleActions)

  if (visibleActions.length === 0) {
    return null
  }

  return (
    <ButtonDropdown
      items={documentActionItems}
      onSelect={(_id, value) => onSelect(value)}
      dropdownClassName={TABLE_CELL_NOT_CLICKABLE_CLASS}
      placement="bottom-end"
      triggerElement={<IconButton icon="ellipsis" variant={triggerVariant} size="sm" />}
      {...rest}
    />
  )
}
